import React from "react";
import styles from "./FormListButton.module.scss";

const FormListButton = ({ text, onClick, className = "", ...rest }) => {
    return (
        <button
            className={`${styles.FormListButton} ${className}`}
            type="button"
            onClick={onClick}
            {...rest}
        >
            {text}
        </button>
    );
};

export default FormListButton;
